module.exports = __webpack_public_path__ + "img/magnum-express.adcd1339.svg";